import { state } from './state';
import mutations from './mutation';
import actions from './action';

export default {
  state,
  mutations,
  actions
};
